import pushClevertapEvent from 'clevertap/pushClevertapEvent';

/**
 * Created by alvinoktavianus on 10/10/17
 */

export function libraryPromoStart() {
  pushClevertapEvent('Promo Start');
}

export function libraryPromoCreate(newPromoData) {
  pushClevertapEvent('Promo Create', newPromoData);
}

export function libraryPromoUpdate({
  promoName,
  appliesMultiple,
  haveTimePeriod,
  assignedOutlet,
}) {
  pushClevertapEvent('Promo Update', {
    'Promo Name': promoName,
    'Promo Configuration': {
      'Applies in Multiple': appliesMultiple,
      'Time Period': haveTimePeriod,
      'Assigned Outlet': assignedOutlet,
    },
  });
}

export function libraryPromoDeleteReactivateDeactivate(
  eventName,
  { promoType, promoName, outlet }
) {
  pushClevertapEvent(eventName, {
    'Promo Type': promoType,
    'Promo Name': promoName,
    'Outlet Name': outlet,
  });
}
